import Component from '../../js/_Component';
import $ from 'jquery';

const CNAME = 'c-block-filter';

type FilterOptions = {
	type: string,
	partial: boolean,
	hint: string,
	options: {
		value: string,
		label: string,
	}[],
	total: number,
};

type SearchParameter = {
	filter?: number,
	value: any
}

export default class BlockFilter extends Component {

	private groupId: number;

	private page = 1;

	private resultContainer: HTMLElement;

	private filters: HTMLElement[];

	private lastSearchParameters: SearchParameter[] = [{
		value: '',
	}];

	private hasGlobalTextSearch = false;

	private busyLocks = 0;

	constructor(element: HTMLElement) {
		super(element);

		this.resultContainer = this.element.querySelector(`.${CNAME}--result-section`);

		this.filterBar = this.element.querySelector(`.${CNAME}--filter-bar`);

		this.groupId = parseInt(this.filterBar.dataset.group);

		this.filters = Array.from(this.element.querySelectorAll(`.${CNAME}--filter-input`));

		this.imageTextGrid = this.filterBar.dataset.group == 'images-and-text-grid' ? true : false;
		// will need to refactor out jQuery
		// add new jquery case-sensitive Contains filter
		// New selector
		$.expr[':'].Contains = function(a, i, m) {
		 return $(a).text().toUpperCase()
			 .indexOf(m[3].toUpperCase()) >= 0;
		};

		 if(!this.imageTextGrid){
            this.element.querySelector(`.${CNAME}--load-button button`).addEventListener('click', () => { return this.loadMore(); });
            }

            this.element.querySelector(`.${CNAME}--search-button button`).addEventListener('click', () => {
            if(this.imageTextGrid){
            	return this.gridSearch();
            }
            return this.newSearch();

            });
            this.element.querySelector(`.${CNAME}--clear-button button`).addEventListener('click', () => {
            if(this.imageTextGrid){
            	return this.gridSearchClearFilters();
            }
            return this.clearFilters();
            });
            this.element.querySelector(`.${CNAME}--filter-bar`).addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {

                   if(this.imageTextGrid){
						return this.gridSearch();
					}
           			 return this.newSearch();
                }
            });


		// Get search parameters from URL.
		let currentUrl = new URL(window.location.href);
		let rawParams = currentUrl.searchParams.get('s');
		let params = null;
		if (!rawParams) {
			if(!this.imageTextGrid){
            	this.loadMore(); // Retrieve default page of data if there are no params.
            }
		} else {
			try {
				rawParams = atob(rawParams);
				params = JSON.parse(rawParams);
			} catch {}
		}

		// Retrieve filter information.
		this.setBusy();
		let filtersLoaded = Promise.resolve();
		this.filters.forEach(filter => {
			if (filter.dataset.filter === '' || this.imageTextGrid) {
				if(filter.dataset.filter === 'filterGroup'){
					let select = document.createElement('select');
					let groupArray = filter.dataset.group.split('|');
					groupArray.forEach(function(item,index){
						var option = document.createElement('option');
						option.value = item.toLowerCase().replace(/ /g,'');
						option.innerText = item;
						select.appendChild(option);
					})
					filter.appendChild(select);
				}else{
					this.hasGlobalTextSearch = true;
					let input = document.createElement('input');
					if (params && params['']) {
						input.value = params[''];
					}
					filter.appendChild(input);
				}
				return;
			}
			let filterId = parseInt(filter.dataset.filter);
			filtersLoaded = filtersLoaded
				.then(() => this.getFilterOptions(filterId))
				.then(options => {
					if (options.type === 'multiple' || options.type === 'single') {
						let select = document.createElement('select');
						let allOption = document.createElement('option');
						allOption.innerText = 'All';
						allOption.value = '';
						select.appendChild(allOption);
						options.options.forEach((item, index) => {
							let option = document.createElement('option');
							option.value = item.value;
							option.innerText = item.label;
							select.appendChild(option);
							if (params && params[filterId] == item.value) {
								select.selectedIndex = index + 1; // Offset by one to account for the new "all" parameter.
							}
						});
						filter.appendChild(select);
						if (options.type === 'multiple') {
							filter.dataset.multiple = '';
						}
					} else if (options.type === 'string') {
						let input = document.createElement('input');
						if (params && params[filterId]) {
							input.value = params[filterId];
						}
						filter.appendChild(input);
					}
				})
				.catch(this.reportSearchError);
		});
		filtersLoaded.then(() => {
			this.unsetBusy();
			if (params) {
				this.newSearch();
			}
		});
	}

	getFilterOptions(filterId: number) {
		return fetch(`/?action=reliquary/search/get-filter-options&filter=${filterId}`, {
			headers: {
				'Accept': 'application/json',
			},
		}).then(results => results.json() as Promise<FilterOptions>);
	}

	clearFilters() {
		this.filters.forEach(filter => {
			let input = this.getFilterInput(filter);
			if (input instanceof HTMLSelectElement) {
				input.selectedIndex = 0;
			} else {
				input.value = '';
			}
		});
		this.newSearch();
	}

	getFilterInput(filter: HTMLElement) {
		return filter.querySelector('select, input') as HTMLSelectElement | HTMLInputElement;
	}

	clearResults() {
		this.element.classList.remove('m-no-more');
		this.resultContainer.innerHTML = '';
	}


	gridSearch(){
	// set all to visible
		let noResultsMsg = "<div class='p-full grid-error-msg'><div class='c-base-text h-type h-type--theme-dark-type'><h2>No Results</h2></div></div>";

		let input = this.getFilterInput(this.filters[0]);
		let searchVal = input.value;
// jQuery cheat to just be done
		let targetGrid = $(this.element).next();
		let errorMsgCheck = $('.grid-error-msg', targetGrid);
		if(errorMsgCheck.length === 0){
			$(targetGrid).prepend(noResultsMsg);
			$('.grid-error-msg', targetGrid).hide();
		}else{
			$(errorMsgCheck).hide();
		}
		let gridItems = $('[data-group]', targetGrid);
		$(gridItems).show();
		// narrow by selector first
		let selectVal = $('select', this.element).val();

		if(selectVal !== 'all'){
			let selectGroup = $(gridItems).filter("[data-group*='" + selectVal + "']");
			if(selectGroup.length > 0){
				$(gridItems).hide();
				$(selectGroup).show();
				gridItems = selectGroup;
			}
		}

		if(searchVal !== '') {
			let results = $('h3:Contains(' + searchVal + '), p:Contains(' + searchVal + ')',gridItems);
			$(gridItems).hide();
			if(results.length > 0){
				$(results).parents('[data-group]').show();
			}else{
				$(errorMsgCheck).show();
			}
		}
	}

	gridSearchClearFilters(){
		let gridContainer = $(this.element).next();
		this.filters.forEach((filter) => {
			let input = this.getFilterInput(filter);
			if (input instanceof HTMLSelectElement) {
				input.selectedIndex = 0;
			}
			else {
				input.value = '';
			}
		});
		$('[data-group]', gridContainer).show();
		$('.grid-error-msg',gridContainer).hide();
	}

	newSearch() {
		if (this.busyLocks) {
			return;
		}

		// Retrieve all filter values.
		this.lastSearchParameters = [];
		this.filters.forEach(filter => {
			if (filter.dataset.filter === '') {
				this.lastSearchParameters.push({
					value: this.getFilterInput(filter).value,
				});
			} else if (this.getFilterInput(filter).value) {
				if (filter.dataset.multiple !== undefined) {
					this.lastSearchParameters.push({
						filter: parseInt(filter.dataset.filter),
						value: [this.getFilterInput(filter).value],
					});
				} else {
					this.lastSearchParameters.push({
						filter: parseInt(filter.dataset.filter),
						value: this.getFilterInput(filter).value,
					});
				}
			}
		});

		// Build a string to use in the URL for this search.
		let urlParameters = {};
		this.lastSearchParameters.forEach((item) => {
			urlParameters[item.filter || ''] = item.value;
		});
		if (this.lastSearchParameters.length) {
			let fullUrl = new URL(window.location.href);
			fullUrl.searchParams.set('s', btoa(JSON.stringify(urlParameters)));
			history.replaceState({}, '', fullUrl.href);
		}

		// Provide a dummy text search filter if one isn't available in the filter bar for the user.
		if (!this.hasGlobalTextSearch) {
			this.lastSearchParameters.push({
				filter: null,
				value: '',
			});
		}

		this.page = 1; // Reset the page number for new searches.

		this.clearResults();
		this.loadMore();
	}

	addResults(results: string) {
		this.unsetBusy();
		let newElement = document.createElement('div');
		newElement.innerHTML = results;
		Array.from(newElement.children).forEach((item: HTMLElement) => {
			if (item.dataset.lastResults !== undefined) {
				this.element.classList.add('m-no-more');
			} else {
				this.resultContainer.appendChild(item);
			}
		});
	}

	reportSearchError() {
		this.unsetBusy();
	}

	loadMore() {
		if (this.busyLocks) {
			return;
		}
		this.setBusy();
		fetch('/?action=reliquary/search/search', {
			method: 'POST',
			headers: {
				'Accept': 'text/html',
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: `group=${this.groupId}&page=${this.page}&${this.searchParametersToURI(this.lastSearchParameters)}`,
		}).then(results => results.text())
			.then(r => this.addResults(r))
			.catch(() => this.reportSearchError());

		this.page += 1; // Ensure the next iteration fetches the next page.
	}

	searchParametersToURI(arr: SearchParameter[]) {
		let elements = [];
		arr.forEach(function(item, index) {
			if (item.filter !== undefined) {
				elements.push(`options[${index}][filter]=${item.filter}`);
			}
			if (Array.isArray(item.value)) {
				item.value.forEach(val => {
					elements.push(`options[${index}][value][]=${encodeURIComponent(val)}`);
				})
			} else {
				elements.push(`options[${index}][value]=${encodeURIComponent(item.value || '')}`);
			}
		});
		return elements.join('&');
	}

	// Increments the busy counter, locking interaction.
	private setBusy() {
		this.busyLocks += 1;
		this.element.classList.add('m-busy');
	}

	// Decrements the busy counter, possibly unlocking interaction.
	private unsetBusy() {
		this.busyLocks -= 1;
		if (!this.busyLocks) {
			this.element.classList.remove('m-busy');
		}
	}
}

Component.register(BlockFilter, 'BlockFilter');
